module.exports = __webpack_public_path__ + "media/images/flags/64/Canada-4875873009430b4754e1ced8143c8c04.png";